import React, { useState, useEffect } from 'react';

function DashboardActiveMainBestLap({value}) {
    var bestLap = value["best-time"]
    var currentLap = parseInt(value["completed-laps"] - 1) === -1 ? 0 : parseInt(value["completed-laps"] - 1)
    const [bestLapNumber, setBestLapNumber] = useState(0)
    const [changeBestLapNumber, setChangePrevBestLapNumber] = useState(false)

    useEffect(() => {
        setChangePrevBestLapNumber(true)
    }, [bestLap]);

    useEffect(() => {
        if (changeBestLapNumber) {
            setBestLapNumber(currentLap)
            setChangePrevBestLapNumber(false)
        }
    }, [changeBestLapNumber, currentLap]);

    return (
        <div className="rounded-lg bg-[#233648]/30 p-3 border border-[#324d67]/50">
            <div className="flex justify-between items-center mb-1">
                <span className="text-[10px] uppercase font-bold text-[#92adc9]">Best Lap</span>
                <span className="material-symbols-outlined text-xs text-primary">stars</span>
            </div>
            <div className="flex justify-between items-end">
                <p className="text-xl font-bold font-mono text-primary">{value["best-time"]}</p>
                <span className="text-[10px] bg-primary/20 text-primary px-1.5 rounded">L{bestLapNumber}</span>
            </div>
        </div>
    );
}

export default DashboardActiveMainBestLap;